// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2ctup","title":"Header_title__3IGwK","side":"Header_side__1C4wb"};